<template>
    <div class="tableState">
        <div class="tableState_left">
            <ul>
                <li v-for="(item,index) in stateData" :class="{active:tableStateActive==item.tzlx}"
                    @click="tableState(item.tzlx,index)">
                    <span>{{item.name}}</span>
                    <div>{{item.tjNum}}</div>
                </li>
            </ul>
            <el-icon class="" @click.stop="selectState">
                <setting/>
            </el-icon>
        </div>
        <div class="tableState_right">
            <div class="tableState_collect" style="display:none" :class="{'active':workorderCollectActive}" @click="workorderCollect">
                <div class="tableState_collect_icon">
                    <el-icon>
                        <star/>
                    </el-icon>
                    <el-icon><StarFilled /></el-icon>
                </div>
                <span>收藏工单</span>
            </div>
            <div class="tableState_add" @click="workOrderImport" v-if="inputBtnShow">
                <el-icon>
                    <plus/>
                </el-icon>
            </div>
        </div>
        <div class="tableState_set" @click.stop :style="{display:selectStateDisplay?'flex':'none'}">
            <div class="tableState_set_left">
                <div v-for="(item,index) in stateAllData" :class="{'active':item.active}"
                     @click="choosetableState(index)" class="tableState_set_list">
                    {{item.name}}
                    <!--<div class="tableState_set_num">{{item.num}}</div>-->
                </div>
            </div>
            <el-icon @click="selectStateOver" class="tableState_set_right">
                <setting/>
            </el-icon>
        </div>
    </div>
</template>

<script>
    import {reactive, computed, ref, onMounted, getCurrentInstance,watch,onUnmounted} from 'vue'
    import {useStore} from 'vuex'
    export default {
        name: "tableState",
        props: ["workOrderImportDisplay","tzlxNum"],
        emits: ["workOrderImport"],
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            //录入按钮显隐
            let inputBtnShow = ref(store.state.inputBtnShow)
            const selectStateDisplay = ref(false)
            const tableStateActive = ref("0");
            const tableStateActiveIndex = ref("0");
            let stateData = ref()
            let stateAllData = ref();
            //点击切换选择台账类型
            const tableState = (param,index) => {
                if (tableStateActive.value != param) {
                    tableStateActive.value = param;
                    tableStateActiveIndex.value =index;
                    context.emit("seletedTzlx", param);
                    //重新请求查询用户台账类型及数据
                    // proxy.$axios.post("/jgfast/wgsj/selYhdyGdtzlx").then((res) => {
                    //     stateData.value = res.data;
                    // });
                }
            }
            //从所有台账类型选择需要的台账类型
            const choosetableState = (param) => {
                stateAllData.value[param].active = !stateAllData.value[param].active;
            }
            //选择台账类型的弹框的显隐
            const selectState = () => {
                selectStateDisplay.value = !selectStateDisplay.value;

            }
            //台账类型选择完毕并把选择的类型保存
            const selectStateOver = () => {
                selectStateDisplay.value = !selectStateDisplay.value;
                let selectedType = [];
                stateAllData.value.map((x) => {
                    if (x.active) {
                        selectedType.push(x.tzlx);
                    }
                })
                if (selectedType.length > 0) {
                    selectedType = selectedType.join(",")
                    proxy.$axios.post("/jgfast/wgsj/saveYhdyGdtzlx", {
                        "tzlx": selectedType
                    }).then((res) => {
                        queryUserType();
                    })
                }
            }
            //查询所有台账类型
            const allTzType = function () {
                proxy.$axios.get("/jgfast/wgsj/selGdtzlx").then((res) => {
                    for (var i = 0; i < res.data.length; i++) {
                        res.data[i].active = false;
                    }
                    stateAllData.value = res.data;
                })
            }
            //查询用户保存台账类型
            const queryUserType = (param = false,payload) => {
                proxy.$axios.post("/jgfast/wgsj/selYhdyGdtzlx",payload).then((res) => {
                    stateData.value = res.data;
                    if(!param){
                        tableStateActive.value = res.data[0].tzlx;
                        context.emit("seletedTzlx", res.data[0].tzlx)
                    }else{
                        context.emit("seletedTzlx")
                    }

                });
            }
            //工单导入 start
            const workOrderImport = () => {
                context.emit("workOrderImport", !props.workOrderImportDisplay)
            }
            //收藏工单
            let workorderCollectActive = ref(false)
            const workorderCollect = () => {
                workorderCollectActive.value = !workorderCollectActive.value;
                context.emit("workorderCollect", workorderCollectActive.value)
            }
            //监听新添加工单刷新列表
            const addWorkorderSuccess = computed(()=>{
                //返回的是ref对象
                return store.state.addNewWorkorderSuccess
            })
            watch(addWorkorderSuccess,(newVal)=>{
                if(newVal){
                    store.state.addNewWorkorderSuccess=false;
                    queryUserType(true);
                }
            })
            watch(()=>props.tzlxNum,(newVal)=>{
                stateData.value[tableStateActiveIndex.value].tjNum = newVal.tzlxNum
            },{deep: true})
            onMounted(() => {
                allTzType();
                queryUserType();
                window.addEventListener('click', ()=>{
                    selectStateDisplay.value= false;
                })
            })
            onUnmounted(() => {
                window.removeEventListener('click', ()=>{
                    selectStateDisplay.value= false;
                })
            })
            //工单导入 end
            return {
                stateData,
                tableStateActive,
                stateAllData,
                tableState,
                choosetableState,
                selectStateOver,
                selectStateDisplay,
                workOrderImport,
                selectState,
                workorderCollect,
                workorderCollectActive,
                queryUserType,
                inputBtnShow
            }
        }
    }
</script>

<style scoped>

</style>
